var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.$route.name!=='Login' && _vm.$route.name!=='Admin')?_c('the-header'):_vm._e(),_c('router-view'),(_vm.$route.name!=='Login' && _vm.$route.name!=='Admin')?_c('the-footer'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }